/// <amd-module name="Build/ArtifactsView/Components/ConsumedArtifactsComponent/ConsumedArtifactsTabService" />
import * as React from "react";
import * as Resources from "Build/ArtifactsView/Resources"
import { ITabService } from "VSS/Features/PlatformUI/ContributedTab";
import { Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { Observer } from "VSSUI/Observer";
import { IVssContributedTab } from "VSSUI/Tabs.Types";
import { ObservableArray, ObservableValue, IReadonlyObservableArray } from "VSS/Core/Observable";
import { ConsumedArtifactsView } from "Build/ArtifactsView/Components/ConsumedArtifactsComponent/ConsumedArtifactsView"
import { ConsumedArtifactsData } from "Build/Client/Contracts/DataProvider";

const c_consumedArtifactsDataProviderId = "ms.vss-build-web.run-consumed-artifacts-data-provider";

class ConsumedArtifactsTabService extends VssService implements ITabService {
    public getTabs(tabId: string, contextualData? : any): IVssContributedTab[] | IReadonlyObservableArray<IVssContributedTab> {
        this._initialize();

        if (this._data.value && this._data.value.consumedSources.length > 0) {
            if (this._tabs.length === 0) {
                this._tabs.push(this._tab);
            }
        }

        return this._tabs;
    }

    private _initialize() {
        const data = this._contributionService().getData<ConsumedArtifactsData>(c_consumedArtifactsDataProviderId);
        if (data) {
            this._data.value = data;
        }
    }

    private _renderConsumedArtifacts = (): JSX.Element => {
        return (
            <Observer data = {this._data}>
                {
                    (props: { data: ConsumedArtifactsData | undefined }) => (
                        <ConsumedArtifactsView data={props.data!} />
                    )
                }
            </Observer>
        );
    }

    private readonly _tab: IVssContributedTab = {
        id: "consumedArtifacts",
        name: Resources.ConsumedArtifactsTabName,
        order: 2,
        render: this._renderConsumedArtifacts
    };

    private _contributionService = (): IVssContributionService => {
        return this.pageContext.getService<IVssContributionService>("IVssContributionService");
    }

    private _data: ObservableValue<ConsumedArtifactsData | undefined> = new ObservableValue(undefined);
    private _tabs = new ObservableArray<IVssContributedTab>();
}

Services.add("pipelines-run-consumed-artifacts-tab-provider-service", { serviceFactory: ConsumedArtifactsTabService });